import { Dialog as DialogPrimitive } from '@base-ui/react/dialog';
import { cn } from '@/shared/lib';
import type { DialogContentProps } from '@/shared/ui/dialog/types';
import { dialogStyles } from '@/shared/ui/dialog/styles';

/**
 * The dialog surface itself: portal, backdrop, viewport and popup.
 *
 * `aria-modal` is set here rather than inherited. Base UI supplies
 * `role="dialog"` and the focus trap but leaves the modality announcement to
 * the consumer, and an unannounced modal is invisible to a screen reader.
 */
export function DialogContent({ className, children, ...props }: DialogContentProps) {
  return (
    <DialogPrimitive.Portal>
      <DialogPrimitive.Backdrop className={dialogStyles.backdrop} />
      <DialogPrimitive.Viewport className={dialogStyles.viewport}>
        <DialogPrimitive.Popup
          className={cn(dialogStyles.popup, className)}
          aria-modal="true"
          {...props}
        >
          {children}
        </DialogPrimitive.Popup>
      </DialogPrimitive.Viewport>
    </DialogPrimitive.Portal>
  );
}